module.exports = __webpack_public_path__ + "static/img/微信公众号.5cc74bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/微信公众号.jpg
// module id = ZIU2
// module chunks = 22